module.exports = require('./components/empty');
